import { BaseModel } from "model/BaseModel";
import OrigemProduto from "./OrigemProduto";

export default class FamiliaProduto implements BaseModel {

    id: number;
    codigo: string | null;
    nome: string;
    origemProduto: null | OrigemProduto;

    constructor(
        id = 0,
        codigo = null,
        nome = '',
        origemProduto = null
    ) {
        this.id = id;
        this.codigo = codigo;
        this.nome = nome;
        this.origemProduto = origemProduto;
    }
}